/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react'
import { dataService } from '../../../services/data.services';
import InfiniteScroll from 'react-infinite-scroll-component';

function MerchantDrodown({
    MerchantList,
    selectedFilter,
    handleMerchantOptionClick,
    handleClearFilter,
    GraphKey,
    totalMerchant
}) {
    const [searchMerchant, setSearchMerchant] = useState('');
    const [merchantData, setMerchantData] = useState([])
    const [merchnatDropdownOpen, setMerchantDropDownOpen] = useState(false);
    const [originalMerchantData, setOriginalMerchantData] = useState([]); // New state variable for the original list
    const dropdownRef = useRef(null);
    const [showClearIcon, setShowClearIcon] = useState(false);
    const [defaultCount, setDefaultCount] = useState()
    const [merchantPage, setMerchantPage] = useState(1)
    const [debounceTimer, setDebounceTimer] = useState(null);


    // let debounceTimer;

    const handleSearch = async (value, pageNumber, key) => {
        const searchValue = encodeURIComponent(value)
        const response = await dataService.GetAPI(`merchant-users/list?search=true&search=${searchValue}&page_number=${pageNumber}`)
        if (key) {
            setMerchantData(response?.data?.data);
        } else {
            setMerchantData(prevData => [...prevData, ...response?.data?.data]);
        }
        setDefaultCount(response?.data?.total_count)
    }

    const handleChange = (e) => {
        const { value } = e.target;
        setSearchMerchant(value);

        // here we should display the clear icon the value is not empty
        setShowClearIcon(value !== '');
        setMerchantPage(1)
        setMerchantData([])
        // Clear the previous timer if it exists
        clearTimeout(debounceTimer);

        // Set a new timer to call handleSearch after 300ms
        const timer = setTimeout(() => {
            handleSearch(value, 1, 'search');
        }, 500);
        setDebounceTimer(timer)
    };

    const handleClear = () => {
        setSearchMerchant('');
        setShowClearIcon(false);
        setMerchantData(originalMerchantData); // Reset to the original list of merchants
        setDefaultCount(totalMerchant)
        setMerchantPage(1)
    };

    // const handleDocumentClick = (event) => {
    //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //         // Clicked outside the dropdown
    //         setMerchantDropDownOpen(false);
    //     }
    // };
    const updatePage = () => {
        const page = merchantPage + 1
        setMerchantPage(page)
        handleSearch(searchMerchant, page);
    }
    // useEffect(() => {
    //     document.addEventListener('mousedown', handleDocumentClick);
    //     return () => {
    //         document.removeEventListener('mousedown', handleDocumentClick);
    //     };
    // }, []);

    useEffect(() => {
        setMerchantData(MerchantList);
        setOriginalMerchantData(MerchantList); // Set the original list when MerchantList changes
        setDefaultCount(totalMerchant)
    }, [MerchantList])


    return (
        <div>
            {/* <h1>Selected City: {selectedCity}</h1> */}
            <div className="relative inline-block max-w-[140px] w-[133px] h-9">
                <button
                    data-testid={`merchant-dropdown-${GraphKey}`}
                    onClick={() => setMerchantDropDownOpen(!merchnatDropdownOpen)}
                    style={{ width: '-webkit-fill-available' }}
                    title={selectedFilter === null ? 'Merchant name' : selectedFilter}
                    className="flex items-center justify-between px-[9px] py-2 border-2 w-full border-[#CDCDCD] rounded-md font-normal text-xs text-black pr-8 relative truncate"
                >
                    {/* <p className='truncate'>{merchnatDropdownOpen ? 'Select Merchant' : `${selectedFilter === null ? 'Merchant name' : selectedFilter}`}</p> */}
                    <p className='truncate'>
                        {merchnatDropdownOpen ? (selectedFilter !== null ? selectedFilter : 'Select Merchant') : (selectedFilter === null ? 'Merchant name' : selectedFilter)}
                    </p>
                    <img
                        className={`ml-2 h-4 w-7 transition-transform duration-300 transform absolute top-[7px] right-0 ${merchnatDropdownOpen ? 'rotate-180' : ''}`}
                        src="/assets/images/Black-down-arrow.svg"
                        alt="Arrow"
                        onClick={() => setMerchantDropDownOpen(!merchnatDropdownOpen)}
                    />
                </button>
                {merchnatDropdownOpen && (
                    <div ref={dropdownRef} className="absolute z-10 w-full bg-white shadow-lg rounded-md">
                        <div className='h-max-auto h-auto overflow-auto scrollBar pr-1'>
                            <div className="flex items-center justify-between p-2 border border-[#CDCDCD] rounded relative sticky top-0 bg-white ">
                                <input
                                    type="text"
                                    data-testid="search"
                                    style={{ width: '-webkit-fill-available' }}
                                    className="flex-grow pl-3 pr-7 py-[5px] border border-[#CDCDCD] rounded-md font-normal text-xs text-black w-full outline-0 placeholder:text-xs placeholder:text-[#52555D] placeholder:font-normal sticky top-0"
                                    placeholder="Search"
                                    value={searchMerchant}
                                    onChange={handleChange}

                                />
                                {showClearIcon ? (
                                    <button data-testid="clear-btn" onClick={handleClear} className="absolute right-[18px] top-[50%] transform -translate-y-1/2">
                                        <img src="/assets/images/close-icon.svg" alt='Clear' />
                                    </button>
                                ) : (
                                    <img src="/assets/images/search-gray.svg" alt='' className='absolute right-[18px] top-[16px]' />
                                )}
                            </div>
                            {selectedFilter !== 'All Merchants' && (
                                <button
                                    className='text-black py-2 px-[9px] text-sm font-medium text-left border border-[#CDCDCD] rounded w-full'
                                    data-testid="select-all"
                                    onClick={() => {
                                        handleClearFilter(GraphKey, 'merchant'),
                                        setMerchantDropDownOpen(false)
                                    }}
                                >
                                    All Merchants
                                </button>
                            )}
                            <InfiniteScroll
                                dataLength={merchantData?.length}
                                pageStart={1}
                                //calculating dropdown height based number of records,max height 162px
                                height={merchantData?.length > 4 ? '162' : merchantData?.length * 34}
                                className='scrollBar max-h-[162px]'
                                next={() => updatePage()}
                                hasMore={Math.ceil(defaultCount / 10) === merchantPage ? false : true}
                                useWindow={false}>
                                {merchantData
                                    .filter(item => item.name.toLowerCase().includes(searchMerchant.toLowerCase()))
                                    .map((filteredItem,i) => (
                                        <button
                                            title={filteredItem.name}
                                            key={filteredItem._id} // Assuming _id is unique
                                            data-testid={`${GraphKey}-merchant-${i}`}
                                            onClick={() => {
                                                handleMerchantOptionClick(filteredItem, "merchant");
                                                setMerchantDropDownOpen(false)
                                            }}
                                            className="block w-full px-[9px] py-2 text-left hover:bg-[#EB9DC7] focus:outline-none border border-[#CDCDCD] rounded font-normal text-xs text-black truncate"
                                        >
                                            {filteredItem.name}

                                        </button>
                                    ))}
                            </InfiniteScroll>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MerchantDrodown